module.exports = __webpack_public_path__ + "static/media/EC.9fb714c3.jpg";